import React from 'react';

interface VerifiedProps {
    onClose: () => void;
}

const Verified: React.FC<VerifiedProps> = ({ onClose }) => {
    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="bg-white shadow-lg rounded-lg p-8 text-center max-w-md">
                <h1 className="text-2xl font-bold text-[#25ADD0] mb-4 font-barlow ">Hurry! You're Verified</h1>
                <p className="text-gray-700 text-lg mb-6 font-barlow ">
                    Your account has been successfully verified. You can now explore all features.
                </p>

                <div className="text-[#25ADD0] text-6xl mb-6">
                    &#10003; {/* Unicode for a checkmark */}
                </div>
                <a href='https://posbill.9span.in' className='text-blue-600 underline' rel="noopener noreferrer" target='_blank'>home</a>
            </div>
        </div>
    );
};

export default Verified;
